<mat-slide-toggle #slideToggleRef [checked]="value">{{
  labelObs | async
}}</mat-slide-toggle>
